import {ApiClient} from '@hconnect/apiclient'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ManualKpisQueryKey} from './useManualKpis'

type UseProcessStagesForManualKpisDeleteParams = {
  plantId: string
  options?: UseMutationOptions<unknown, AxiosError, string>
}

export const useProcessStagesForManualKpisDelete = ({
  plantId,
  options
}: UseProcessStagesForManualKpisDeleteParams) => {
  const queryClient = useQueryClient()

  return useMutation<unknown, AxiosError, string>({
    mutationFn: async (processStage: string) => {
      const path = `/shifthandover/${plantId}/process-stages/${processStage}`
      const response = await ApiClient.axiosInstance.delete(path)
      return response.data
    },
    ...options,
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries({queryKey: [ManualKpisQueryKey]})
      await options?.onSuccess?.(data, variables, context, mutation)
    }
  })
}
